import { useNavigate, useLocation } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import { Terminal, GraduationCap, Briefcase, User, LogOut, Mail } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/FloralBg";

const NAV = [
  { to: "/coding", label: "Coding", icon: Terminal },
  { to: "/courses", label: "Courses", icon: GraduationCap },
  { to: "/jobs", label: "Jobs", icon: Briefcase },
  { to: "/contact", label: "Contact", icon: Mail },
];

export default function TopNav() {
  const nav = useNavigate();
  const loc = useLocation();
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const initial = (user?.name || user?.email || "K")[0].toUpperCase();

  return (
    <header className="sticky top-0 z-40 px-4 sm:px-8 py-4 flex items-center justify-between backdrop-blur-md">
      <div className="flex items-center gap-4">
        <div className="relative" ref={ref}>
          <button data-testid="profile-avatar" onClick={() => setOpen((o) => !o)}
                  className="w-11 h-11 rounded-full bg-gradient-to-br from-[#00D4D4] to-[#006666] text-[#052222] font-bold flex items-center justify-center hover:shadow-[0_0_20px_rgba(0,212,212,0.5)] transition-shadow">
            {initial}
          </button>
          {open && (
            <div className="absolute left-0 mt-3 w-60 glass-strong rounded-2xl p-2 fade-up z-50">
              <div className="px-3 py-2 border-b border-border/60 mb-1">
                <div className="font-semibold text-sm truncate">{user?.name}</div>
                <div className="text-xs text-muted-foreground truncate">{user?.email}</div>
              </div>
              <button data-testid="nav-profile" onClick={() => { setOpen(false); nav("/profile"); }}
                      className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-white/5 text-sm">
                <User size={16} className="text-teal-accent" /> Profile
              </button>
              <button data-testid="nav-logout" onClick={() => { logout(); nav("/login"); }}
                      className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-white/5 text-sm text-red-400">
                <LogOut size={16} /> Logout
              </button>
            </div>
          )}
        </div>
        <button onClick={() => nav("/")}><Logo /></button>
      </div>

      <nav className="glass rounded-full p-1.5 flex items-center gap-1">
        {NAV.map(({ to, label, icon: Icon }) => {
          const active = loc.pathname === to || loc.pathname.startsWith(to + "/");
          return (
            <button key={to} data-testid={`nav-${label.toLowerCase()}`} onClick={() => nav(to)}
                    className={`pill px-4 sm:px-5 py-2 text-sm flex items-center gap-2 transition-all ${
                      active ? "bg-[#00D4D4]/15 text-teal-accent shadow-[0_0_18px_rgba(0,212,212,0.25)]" : "text-muted-foreground hover:text-foreground"}`}>
              <Icon size={16} /> <span className="hidden sm:inline">{label}</span>
            </button>
          );
        })}
      </nav>
    </header>
  );
}
